import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const TestAuthPage = () => {
  const { isAuthenticated, user, loading, checkAuthStatus } = useAuth();
  const [apiResponse, setApiResponse] = useState(null);
  const [testingApi, setTestingApi] = useState(false);

  const testApi = async () => {
    setTestingApi(true);
    try {
      const response = await axios.get('/api/getAuthStatus', {
        withCredentials: true
      });
      setApiResponse(response.data);
    } catch (error) {
      setApiResponse({ error: error.message });
    } finally {
      setTestingApi(false);
    }
  };

  const handleGoogleLogin = () => {
    window.location.href = '/.auth/login/google';
  };

  const handleLogout = () => {
    window.location.href = '/.auth/logout';
  };

  useEffect(() => {
    testApi();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Authentication Test Page</h1>
      
      <div style={{ marginBottom: '20px', padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
        <h3>React Hook Status</h3>
        <p><strong>Is Authenticated:</strong> {isAuthenticated ? 'Yes' : 'No'}</p>
        <p><strong>Loading:</strong> {loading ? 'Yes' : 'No'}</p>
        {user && (
          <div>
            <p><strong>User ID:</strong> {user.id}</p>
            <p><strong>Name:</strong> {user.name}</p>
            <p><strong>Email:</strong> {user.email}</p>
            <p><strong>Provider:</strong> {user.provider}</p>
            <p><strong>Roles:</strong> {user.roles?.join(', ') || 'None'}</p>
          </div>
        )}
        <button onClick={checkAuthStatus}>Refresh Hook Status</button>
      </div>

      <div style={{ marginBottom: '20px', padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
        <h3>API Response</h3>
        <button onClick={testApi} disabled={testingApi}>
          {testingApi ? 'Testing...' : 'Test API'}
        </button>
        {apiResponse && (
          <pre style={{ backgroundColor: '#f5f5f5', padding: '10px', marginTop: '10px', borderRadius: '3px' }}>
            {JSON.stringify(apiResponse, null, 2)}
          </pre>
        )}
      </div>

      <div style={{ marginBottom: '20px', padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
        <h3>Authentication Actions</h3>
        {!isAuthenticated ? (
          <button onClick={handleGoogleLogin} style={{ marginRight: '10px' }}>
            Login with Google
          </button>
        ) : (
          <button onClick={handleLogout}>
            Logout
          </button>
        )}
      </div>

      <div style={{ marginBottom: '20px', padding: '15px', border: '1px solid #ddd', borderRadius: '5px' }}>
        <h3>Azure Static Web Apps Authentication Endpoints</h3>
        <p>The following endpoints are automatically available:</p>
        <ul>
          <li><a href="/.auth/login/google">/.auth/login/google</a> - Google Login</li>
          <li><a href="/.auth/login/aad">/.auth/login/aad</a> - Azure AD Login</li>
          <li><a href="/.auth/login/facebook">/.auth/login/facebook</a> - Facebook Login</li>
          <li><a href="/.auth/logout">/.auth/logout</a> - Logout</li>
          <li><a href="/.auth/me">/.auth/me</a> - User Info</li>
        </ul>
      </div>
    </div>
  );
};

export default TestAuthPage;